import Flash from "../img/flash.png";

export const FlashingBorder = ({ flash, onAnimationEnd }) => {

    return (
        <img src={Flash} alt="Moving" className={ flash } onAnimationEnd={onAnimationEnd} />
    );
}

